import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { P_Props } from "./CustomButton.type";
import clsx from "clsx";

const CustomButtonPresenter = React.forwardRef((props: P_Props, ref: any) => {
  const [elementId] = useState(uuidv4());
  const btnId = `btn-${elementId}`;

  const defaultClass = clsx({
    btn: true,
    "btn--transparent": true,
    "btn--shiny": true,
    "btn--hover": props.hover,
    "btn--shadow": props.shadow,
    "btn--opacity": props.opacity,
    "btn--disabled": props.disabled,
    "btn--active": props.active,
    [`btn__${props.shape}`]: props.shape,
  });

  return (
    <button
      disabled={props.disabled}
      type={props.htmlType}
      id={btnId}
      ref={ref}
      onClick={props.onClick}
      onBlur={props.onBlur}
      style={{ ...props.style }}
      className={`${defaultClass} ${props.className}`}
    >
      {props.item}
    </button>
  );
});

CustomButtonPresenter.defaultProps = {
  className: "",
};

export default CustomButtonPresenter;
